<template>
    <section class="feedback_form_wrp">
        <div class="public_bg_clr_wrp">
            <div class="container">
                <template v-if="alreadySubmittedForm">
                    <template v-if="formSubmittedAfterMessage">
                        <h2 class="feedback_form_heading text-center">Demo Request - Feedback</h2>
                        <form @submit.prevent="feedbackFormDataSubmit">
                            <div class="feedback_form">
                                <div class="form-group">
                                    <label>How would you rate this demo session?</label>
                                    <star-rating :animate="true" :rating.sync="currentRating" size="20" :star-type="'fa fa-star'" 
                                        v-model="currentRating" inactive-color="#ffffff" active-color="#ffd400" :show-rating="false" />
                                </div>
                                <div class="form-group">
                                    <label>Suggestions</label>
                                    <textarea type="text" class="form-control" v-model="comment" rows="6"
                                        v-validate="'required'" v-bind:class="{ 'is-invalid': errors.has('comment') }"
                                        name="comment" data-vv-as="comment"></textarea>
                                    <small class="invalid-feedback" v-if="errors.has('comment')">{{
                                        errors.first('comment')
                                        }}</small>
                                </div>
                                <div class="btn_group pt-2">
                                    <button class="btn btn-primary" type="submit">Submit</button>
                                </div>
                            </div>
                        </form>
                    </template>
                    <template v-else>
                        <div class="feedback_form_submitted">
                            <h3 class="feedback_form_response_heading">Thank you for submitting your responses.<br> Our
                                team values your input!
                               <div class="mt-3">
                                    <router-link to="/" class="btn btn-success">Ok</router-link>
                                </div>
                            </h3>
                        </div>
                    </template>
                </template>
                <template v-else>
                    <div class="feedback_form_submitted">
                        <h3 class="feedback_form_response_heading">
                        <template v-if="alreadySubmittedMessage">You have already submitted your responses, and we thank you! <br> Our team values your input.</template>
                        <template v-else>This feedback form has expired.
                            <p class="mt-2">For any questions or support please reach out to us at <a href="mailto:support@lymphomap.ai">support@lymphomap.ai.</a></p></template>
                        <div class="mt-3">
                            <router-link to="/" class="btn btn-success">Ok</router-link>
                        </div>
                    </h3>
                    </div>
                </template>
            </div>
        </div>
    </section>
</template>

<script>
/* eslint-disable */
import toast from '@/services/toast';
import StarRating from 'vue-star-rating';
export default {
    name: 'feedback-form',
    components: { StarRating },
    props: [],
    data() {
        return {
            currentRating: 0,
            comment: '',
            submitted: false,
            alreadySubmittedForm: true,
            formSubmittedAfterMessage: true,
            alreadySubmittedMessage:true,
        }
    },
    computed: {
    },
    created() {
        this.$store.dispatch('demoFeedbackRequestCheckAction', { token: this.$route.params.selfToken }).then((res) => {
            this.alreadySubmittedForm = true
        }).catch((err) => {
            if (err.status == '400') {
                this.alreadySubmittedForm = false;
                if(err.data.code == '4001'){
                    this.formSubmittedAfterMessage = false;
                }
            }
        })
    },
    methods: {
        feedbackFormDataSubmit() {
            this.$validator.validateAll().then((result) => {
                if (result) {
                    this.submitted = true
                    let data = {
                        overall_satisfaction: this.currentRating,
                        suggestions: this.comment,
                        would_recommend:true,
                    }
                    this.$store.dispatch('demoFeedbackSubmitAction', { data: data, token: this.$route.params.selfToken })
                        .then((res) => {
                            this.submitted = false;
                            this.formSubmittedAfterMessage = false;
                            toast.success(res.data.message);
                        }).catch((err) => {
                            if (err.status == '400') {
                                this.submitted = false;
                                this.alreadySubmittedForm = false;
                            } else {
                                toast.error(err.data.msg);
                                this.submitted = false;
                            }
                        })
                    return;
                }
            })
        }

    },
    beforeCreate: function () {
        document.body.classList.add('left_sidebaar_disabled_for_page');
        document.body.classList.add('public_page_for_wrp_img');
    },
    beforeRouteLeave: function (to, from, next) {
        document.body.classList.remove('left_sidebaar_disabled_for_page');
        document.body.classList.remove('public_page_for_wrp_img');
        window.scrollTo(0, 0);
        next();
    },
}
</script>


<style lang="scss" scoped>
.feedback_form_wrp {
    min-height: 100dvh;
    padding: 70px 15px 10px;

    .public_bg_clr_wrp {
        background: rgba(0, 0, 0, 0.92);
        padding: 20px 15px;
        min-height: calc(100dvh - 80px);
        display: flex;
        align-items: center;
        .container{
            background: linear-gradient(-30deg, rgba(37, 44, 84, 0.98), rgba(0, 0, 0, 0.98) 50%, rgba(38, 38, 38, 0.98) 0, rgba(44, 44, 84, 0.98));
            border: 1px solid rgba(93, 93, 93, 0.5);
            border-radius: 10px 10px 15px 15px;
            padding: 20px;
            max-width: 720px;
            margin: 0 auto;
            height: calc(100dvh - 160px);
        }
    }

    .feedback_form_heading {
        font-family: 'origin_tech_demoregular';
        color: #ffd400;
        font-size: 32px;
        margin-bottom: 20px;
    }

    .feedback_form {
        font-size: 16px;
        line-height: 1.3;
        font-family:'MyriadProRegular', 'Lato', sans-serif;
        color: #fff;

        label {
            &.q_text {
                font-size: 18px;
                color: #ffd400;
            }

            span {
                color: #87cefa;
            }
        }

        input[type="radio"] {
            margin-right: 5px;
        }

        .form-group {
            margin-bottom: 30px;
        }

        .form-control {
            padding: 9px 15px;
            background: rgba(255, 255, 255, 0.15);
            border-color: transparent;
            font-size: 18px;
            color: #fff;
            -webkit-transition: all 0.7s cubic-bezier(0.42, 1.14, 1, 1);
            transition: all 0.7s cubic-bezier(0.42, 1.14, 1, 1);
            height: auto;
        }

        .btn-primary {
            background: rgba(255, 255, 255, 0.15);
            color: #ffd400;
            font-size: 18px;
            text-align: center;
            display: -webkit-inline-box;
            display: -ms-inline-flexbox;
            display: inline-flex;
            -webkit-box-pack: center;
            -ms-flex-pack: center;
            justify-content: center;
            -webkit-box-align: center;
            -ms-flex-align: center;
            align-items: center;
            white-space: nowrap;
            min-width: 110px;
            min-height: 30px;
            border-radius: 4px;
            -webkit-box-shadow: none;
            box-shadow: none !important;
            border: none !important;
            outline: none !important;

            &:hover {
                background: #87cefa;
                color: #333;
            }
        }
    }

    .feedback_form_submitted {
        width: 100%;
        flex: 0 0 100%;
        height: 100%;
        display: flex;
        align-items: center;

        .feedback_form_response_heading {
            //font-family: 'origin_tech_demoregular';
            font-family: 'MyriadProRegular', 'Lato', sans-serif;
            color: #fff6c7;
            margin-bottom: 0px;
            font-size: 20px;
            line-height: 1.5;
            width: 100%;
            text-align: center;
            p{
             & > a{color: #87cefa; &:hover{color:#ffd400;}}
            }
        }
        .btn-success {
            box-shadow: none !important;
            border: none !important;
            min-width: 100px;
            background: rgba(33, 228, 0, 0.5);
            &:hover{
                background: #ffe738 !important;
                color: #22292f !important;
            }
        }
    }
}
</style>